<!-- two-fa-reminder.component.html -->
<div class="container py-5" style="max-width: 520px;">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">SwipFx</h2>
    <div class="text-muted">Two-factor verification</div>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">
    {{ error }}
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-4">

      <div class="mb-3">
        <h5 class="fw-bold mb-2">Secure your account with 2FA</h5>
        <div class="text-muted">
          Enable two-factor authentication to add an extra layer of protection to your account.
          You can set it up now or choose to be reminded later.
        </div>
      </div>

      <div class="d-grid gap-2">
        <button class="btn btn-primary" type="button" (click)="setup2fa()" [disabled]="loading">
          Set up 2FA
        </button>

        <button class="btn btn-outline-secondary" type="button" (click)="postpone30()" [disabled]="loading">
          Remind me in 30 days
        </button>

        <button class="btn btn-link text-decoration-none" type="button" (click)="noThanks()" [disabled]="loading">
          No thanks
        </button>
      </div>

    </div>
  </div>

  <div class="text-center mt-3 text-muted small">
    By continuing, you agree to SwipFx terms.
  </div>
</div>